import React, { Component, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { NoInformation } from "./Panel";

function ListSearch ({onClearClick, results, placeholder, onSearchClick, children }) {
    const { t } = useTranslation();
    const [searchInput, setSearchInput] = useState('');

    const onChange = (e) => {
        setSearchInput(e.target.value)
    }

    const onSearchEnter = () => {
        if (searchInput.length === 0) {
            return null;
        }

        onSearchClick(searchInput);
    }

    const onKeyClick = (e) => {
        if (e.key === "Enter") {
            onSearchEnter();
        }
    }

    const onCloseClick = () => {
        setSearchInput('');
        onClearClick();
    }

    function renderResults(results) {

        if (!results) {
            return null;
        }
        
        if(!results.length)
            return <NoInformation />
        
        return [
            <button key={100000} className="btn btn-default btn-sm pull-right" type="button" onClick={onCloseClick}>{t('listsearch.clear')}</button>,
            <h3 key={123}>{results.length} {t('listsearch.resultsfound')}</h3>,            
            children
        ]
    }

        return <div className="appointmentSearch">
                        <div className="form-group search-group">
                            <input type="text" className="form-control" value={searchInput} aria-describedby="searchBlock" placeholder={placeholder} onChange={(e) => onChange(e)} onKeyPress={(e) => onKeyClick(e)}/>
                                <button type="button" className="btn btn-default btn-sm search-icon" onClick={onSearchEnter}></button>
                        </div>
                    {renderResults(results)}
                </div>
}

export default ListSearch;